export default {
	tabs: {
		notDefined: 'NotDefined',
		journal: 'Journal',
		invoice: 'Invoice',
		reconciliation: 'Reconciliation',
		all: 'All'
	}
}